export function toWhatsAppDigitsRegional(input) {
  if (!input) return null;
  
  // Convert to string and clean up
  const cleaned = input.toString().trim();
  
  // Remove all non-digit characters except leading +
  let digits = cleaned.replace(/[^0-9+]/g, '');
  
  // If it starts with +, keep it as is (international format)
  if (digits.startsWith('+')) {
    // Remove the + and any non-digit characters
    digits = digits.substring(1).replace(/\D/g, '');
    return digits; // Return without the + as WhatsApp web expects
  }
  
  // If it's just numbers, assume it's already in international format without the +
  if (/^\d+$/.test(digits)) {
    // If it starts with 0, assume it's a local number and add South Africa's country code
    if (digits.startsWith('0')) {
      return '27' + digits.substring(1);
    }
    return digits;
  }
  
  // If we get here, the number is invalid
  return null;
}
